/**
 * React Query Configuration
 * QueryClient 全域設定
 */

import { QueryClient, DefaultOptions } from '@tanstack/react-query'

/**
 * 預設 Query 選項
 */
const defaultOptions: DefaultOptions = {
  queries: {
    // 資料保持新鮮的時間（預設關閉，每次都重新驗證）
    staleTime: 0,

    // 快取時間（5 分鐘）
    gcTime: 5 * 60 * 1000,

    // 失敗時重試次數
    retry: 1,

    // 失敗時重試延遲（指數退避）
    retryDelay: (attemptIndex: number) =>
      Math.min(1000 * 2 ** attemptIndex, 30000),

    // 視窗重新聚焦時不自動重新請求
    refetchOnWindowFocus: false,

    // Mount 時不自動重新請求
    refetchOnMount: false,

    // 重新連線時不自動重新請求
    refetchOnReconnect: false,
  },
  mutations: {
    // Mutation 失敗時重試次數
    retry: 0,
  },
}

/**
 * 建立 QueryClient Instance
 */
export const queryClient = new QueryClient({
  defaultOptions,
})

/**
 * Query Keys Factory
 * 統一管理所有的 query keys
 */
export const queryKeys = {
  leaderboard: (lessonId: string, gameId: string) =>
    ['leaderboard', lessonId, gameId] as const,
} as const
